<template>
  <section class="quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <table
          v-if="!item.isCompare"
          class="table"
          :class="item.class">
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <td>{{ sumItem.name }}</td>
            <template v-if="sumItem.type!='array'">
              <template v-if="sumItem.field=='post_nm_id'">
                <td v-if="formData.post_nm_id === oldForm.post_nm_id&&formData.post_nm_other === oldForm.post_nm_other">
                  {{sumItem.value }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span class="text-line color-danger">
                    {{ `${getAllOptionName26('mortgagor',oldForm.post_nm_id)} ${oldForm.post_nm_other}` }}
                  </span>
                  <span class="color-success">
                    {{ sumItem.value }}
                  </span>
                </td>
              </template>
              <template v-else>
                <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span class="text-line color-danger">
                    {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                  </span>
                  <span class="color-success">
                    {{ showCompare(sumItem, formData[sumItem.field]) }}
                  </span>
                </td>
              </template>
            </template>
            <template v-else>
              <td>
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index">{{sum.item}}<br></span>
              </td>
            </template>
          </tr>
        </table>
        <table
          v-else
          class="table"
          :class="item.class">
          <template v-if="formData.cust_typ == 1">
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr">
              <td>{{ sumItem.name }}</td>
              <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </td>
              <td
                v-else
                class="compare">
                <span class="text-line color-danger">
                  {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                </span>
                <span class="color-success">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </span>
              </td>
            </tr>
          </template>
          <template v-else>
            <div
              v-for="(sumItem,sumIndex) in item.list1"
              v-show="!sumItem.notShow"
              :key="sumIndex">
              <tr
                v-if="!sumItem.isSumbTitle"
                class="tr">
                <td>{{ sumItem.name }}</td>
                <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span class="text-line color-danger">
                    {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                  </span>
                  <span class="color-success">
                    {{ showCompare(sumItem, formData[sumItem.field]) }}
                  </span>
                </td>
              </tr>
              <td
                v-else
                class="title">{{ sumItem.name }}</td>
            </div>
          </template>
        </table>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <table
          v-if="!item.isCompare"
          class="table"
          :class="item.class">
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <td>{{ sumItem.name }}</td>
            <template v-if="sumItem.type == 'value'">
              <td
                v-copy="sumItem.value">
                {{ sumItem.value }}
              </td>
            </template>
            <template v-else>
              <td
                v-if="sumItem.type == 'file'"
                class="blue pointer"
                @click="openFile(sumItem.value.url)">
                {{ getClientName(sumItem.value) }}
              <!--              {{ sumItem.value.client_name }}-->
              </td>
              <td
                v-if="sumItem.type == 'array'"
              >
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index"
                  v-copy="sum.name">{{sum.name}}<br></span>
              </td>
              <td
                v-else
                v-copy="showCompare(sumItem, formData[sumItem.field])">
                <span  v-if="sumItem.type == 'value'">{{ sumItem.value }}</span>
                <span v-else>{{ showCompare(sumItem, formData[sumItem.field]) }}</span>
              </td>
            </template>
          </tr>
        </table>
        <table
          v-else
          class="table"
          :class="item.class">
          <template v-if="formData.cust_typ == 1">
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr">
              <td>{{ sumItem.name }}</td>

              <td
                v-if="sumItem.type == 'value'&&!sumItem.option"
                v-copy="sumItem.value">
                {{ sumItem.value }}
              </td>
              <td
                v-else-if="sumItem.type == 'value'&&sumItem.option"
                v-copy="getName(sumItem.value)">
                {{ getName(sumItem.value) }}
              </td>
              <td
                v-else-if="sumItem.type == 'file'"
                v-copy="sumItem.value&&sumItem.value.client_name"
                class="blue pointer"
                @click="openFile(sumItem.value.url)">
                {{ sumItem.value&&sumItem.value.client_name }}
              </td>
              <td
                v-if="sumItem.type == 'array'"
              >
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index"
                  v-copy="sum.name">{{sum.name}}<br></span>
              </td>
              <td
                v-else
                v-copy="showCompare(sumItem, formData[sumItem.field],sumItem.field)">
                {{ showCompare(sumItem, formData[sumItem.field],sumItem.field) }}
                <email-tooltip
                  v-if="sumItem.field == 'email'"
                  :email="formData.email"></email-tooltip>
              </td>
            </tr>
          </template>
          <template v-else>
            <div
              v-for="(sumItem,sumIndex) in item.list1"
              v-show="!sumItem.notShow"
              :key="sumIndex">
              <tr
                v-if="!sumItem.isSumbTitle"
                class="tr">
                <td>{{ sumItem.name }}</td>
                <td v-if="sumItem.type == 'value'">
                  {{ sumItem.value }}
                </td>
                <!--                <span v-else-if="sumItem.type == 'value'&&sumItem.option">-->
                <!--                  {{ getName(sumItem.value) }}-->
                <!--                </span>-->
                <td
                  v-else-if="sumItem.type == 'file'"
                  class="blue pointer"
                  @click="openFile(sumItem.value.url)">
                  {{ getClientName(sumItem.value) }}
                </td>
                <td v-else>
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                  <email-tooltip
                    v-if="sumItem.field == 'email'"
                    :email="formData.email"></email-tooltip>
                </td>
              </tr>
              <td
                v-else
                class="title">{{ sumItem.name }}</td>
            </div>
          </template>
        </table>
      </div>
    </template>

    <!-- <div class="box">
      <h3>Owner's Liability</h3>
      <div class="table">
        <div class="tr">
          <span>Owner's Liability</span>
          <span>{{ getOptionName('yesNoOptions', formData.owner_liability_ind) }}</span>
        </div>
        <div class="tr">
          <span>Sum Insured of Owner's Liability</span>
          <span>{{ getAllOptionName26('owner_liability', formData.sum_owner_liability) }}</span>
        </div>
      </div>
    </div> -->

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import OMath from '@/utils/math'
import {mapState} from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'HomefireQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // compareData: [
      //   {
      //     title: '',
      //     class: 'mg-b-10',
      //     list:
      //       [
      //         {
      //           name: 'Effective Date',
      //           field: 'pcy_cmnt_dt'
      //         },
      //         {
      //           name: 'Building Type',
      //           field: 'bldg_typ',
      //           fieldCode: 'bldg_types',
      //           option: 26
      //         },
      //         {
      //           name: 'Property Age',
      //           field: 'prop_age',
      //           fieldCode: 'prop_age',
      //           option: 26
      //         },
      //         {
      //           name: 'Occupancy',
      //           field: 'prop_insured',
      //           fieldCode: 'prop_insured',
      //           option: 26
      //         },
      //       ]
      //   },
      //   {
      //     title: 'Proposed Location of Risk',
      //     isBold: false,
      //     list: [
      //       {
      //         name: 'Room',
      //         field: 'insured_addr_room'
      //       }, {
      //         name: 'Floor',
      //         field: 'insured_addr_floor'
      //       }, {
      //         name: 'Block',
      //         field: 'insured_addr_block'
      //       }, {
      //         name: 'Building / Estate',
      //         field: 'insured_addr_building'
      //       }, {
      //         name: 'Street',
      //         field: 'insured_addr_street'
      //       }, {
      //         name: 'District',
      //         field: 'insured_addr_district',
      //         addressCode: 'district',
      //         isAddress: true
      //       }, {
      //         name: 'Area',
      //         field: 'insured_addr_area',
      //         addressCode: 'area',
      //         isAddress: true
      //       }, {
      //         name: 'Country / Region',
      //         field: 'insured_addr_region',
      //         addressCode: 'region',
      //         isAddress: true,

      //       },
      //     ]
      //   },
      //   {
      //     title: 'Policyholder Detail',
      //     isCompare: true,
      //     isBold: true,
      //     list: [
      //       {
      //         name: 'Title',
      //         field: 'isrd_title',
      //         fieldCode: 'titleOptions',
      //         option: 1
      //       }, {
      //         name: 'Name',
      //         field: 'isrd_lst_nm'
      //       }, {
      //         name: 'First Name',
      //         field: 'isrd_fst_nm'
      //       }, {
      //         name: 'Date of Birth',
      //         field: 'isrd_dob'
      //       }, {
      //         name: 'HKID',
      //         field: 'id_no'
      //       }, {
      //         name: 'Mobile Number',
      //         field: 'mobile_no',

      //       }, {
      //         name: 'Email',
      //         field: 'email',

      //       }, {
      //         name: 'Occupation',
      //         field: 'occ',
      //         fieldCode: 'occupation',
      //         option: 26,
      //       },
      //     ],
      //     list1: [
      //       {
      //         name: 'Company Name',
      //         field: 'isrd_com_nm'
      //       }, {
      //         name: 'BR Number',
      //         field: 'id_no'
      //       }, {
      //         name: 'CI Number',
      //         field: 'ci_no'
      //       }, {
      //         name: 'Company Phone No.',
      //         field: 'phone_no'
      //       }, {
      //         name: 'Company Email',
      //         field: 'email'
      //       }, {
      //         name: 'Nature of Business',
      //         field: 'bsns_nature_id',
      //         fieldCode: 'industry',
      //         option: 26
      //       },
      //       {
      //         name: 'Contact Person',
      //         isSumbTitle: true
      //       },
      //       {
      //         name: 'Name',
      //         field: 'contact_nm',

      //       }, {
      //         name: 'Occupation',
      //         field: 'contact_occ_id',
      //         fieldCode: 'occupation',
      //         option: 24,
      //       },
      //       {
      //         name: 'Phone No.',
      //         field: 'contact_phone',
      //       },
      //       {
      //         name: 'Email',
      //         field: 'contact_email',

      //       },
      //     ]
      //   },
      //   {
      //     title: 'Correspondence Address',
      //     isBold: false,
      //     list: [
      //       {
      //         name: 'Room',
      //         field: 'addr_room'
      //       }, {
      //         name: 'Floor',
      //         field: 'addr_floor'
      //       }, {
      //         name: 'Block',
      //         field: 'addr_block'
      //       }, {
      //         name: 'Building / Estate',
      //         field: 'addr_building'
      //       }, {
      //         name: 'Street',
      //         field: 'addr_street'
      //       }, {
      //         name: 'District',
      //         field: 'addr_district',
      //         addressCode: 'district',
      //         isAddress: true
      //       }, {
      //         name: 'Area',
      //         field: 'addr_area',
      //         addressCode: 'area',
      //         isAddress: true
      //       }, {
      //         name: 'Country / Region',
      //         field: 'addr_region',
      //         isAddress: true,
      //         addressCode: 'region'
      //       },
      //     ]
      //   },
      //   {
      //     title: 'Coverage',
      //     isSum: true,
      //     isBold: true,
      //     list: [
      //       {
      //         name: 'Sum Insured',
      //         field: 'sum_insured',
      //         isSum: true,
      //       }
      //     ]
      //   },
      //   {
      //     title: 'Section 1 – Household Contents “All Risks”',
      //     isBold: false,
      //     list: [
      //       {
      //         name: 'Gross Floor Area in sq ft.',
      //         field: 'floor_area',
      //         option: 26,
      //         fieldCode: 'floor_area'
      //       },
      //       {
      //         name: 'Mobile Phone 1 Model declaration',
      //         field: 'phone_mdl_1'
      //       },
      //       {
      //         name: 'Mobile Phone 2 Model declaration',
      //         field: 'phone_mdl_2'
      //       }
      //     ]
      //   }
      // ]
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isSameAddress() {
      return this.formData.is_same_as_corr_addr == 1
    },
    isOther(){
      let {post_nm_id} = this.formData||{}
      let data ={}
      let {mortgagor=[] } = this.allOptions26||{}
      mortgagor.some(item => {
        if (item.id == post_nm_id) {
          data = item
          return true
        }
        return false
      })
      return data.is_other||''
    },
    compareData() {
      let {quote_coverage_list={},benefits,post_nm_id,post_nm_other,prop_insured} = this.formData||{}
      let benefitsList = this[`allOptions${this.formData.class_id}`].benefits || []
      let arr =[]
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return this.formData.benefits.includes(item.id)
        })
      }
      let post_name = this.getAllOptionName26('mortgagor',post_nm_id)
      if(this.isOther==1){
        post_name = post_name + ' ' +post_nm_other
      }
      let isTenat = prop_insured==3
      let list = [
        {
          title: '',
          class: 'mg-b-10',
          list:
            [
              {
                name: 'Expected Effective Date ',
                field: 'pcy_cmnt_date',
                type:'value',
                value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.formData.pcy_cmnt_date} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`
              },
              {
                name: 'Expected Expiry Date ',
                field: 'pcy_expry_date',
                // option:10
              },
              {
                name: 'Type of Building',
                field: 'bldg_typ',
                fieldCode: 'bldg_types',
                option: 26
              },
              {
                name: 'Gross Floor Area (Indoor & Outdoor)',
                field: 'floor_area',
                fieldCode: 'floor_area',
              },
              {
                name: 'Property Age',
                field: 'prop_age',
                fieldCode: 'prop_age',
                option: 26
              },
              {
                name: 'Occupancy',
                field: 'prop_insured',
                fieldCode: 'prop_insured',
                option: 26
              },
              {
                name: 'Does the flat have a roof/garden/balcony/workspace or on the lower floor (1st to 3rd floor)?',
                type: 'value',
                value:this.getAllOptionName26('has_roof',this.formData.has_roof) ,
                notShow:this.formData.has_roof==-1
              },
              {
                name: 'Is your Location of Risk same as Correspondence Address?',
                field: 'is_same_as_corr_addr',
                fieldCode: 'yesNoOptions',
                option: 1
              },
              {
                name: 'Optional Benefits',
                field: 'benefits',
                type:'array',
                value:arr
              },
              {
                name: 'Insurer',
                field: 'company_language',
                notShow:!this.showCompany
              },
            ]
        },
        {
          title: 'Location of Risk',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: this.isSameAddress? 'addr_room': 'insured_addr_room'
            }, {
              name: 'Floor',
              field: this.isSameAddress? 'addr_floor': 'insured_addr_floor'
            }, {
              name: 'Block',
              field: this.isSameAddress? 'addr_block': 'insured_addr_block'
            }, {
              name: 'Building / Estate',
              field: this.isSameAddress? 'addr_building': 'insured_addr_building'
            }, {
              name: 'Street',
              field: this.isSameAddress? 'addr_street': 'insured_addr_street'
            }, {
              name: 'District',
              field: this.isSameAddress? 'addr_district': 'insured_addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: this.isSameAddress? 'addr_area': 'insured_addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: this.isSameAddress? 'addr_region': 'insured_addr_region',
              addressCode: 'region',
              isAddress: true,

            },
          ]
        },
        {
          title: 'Policyholder Detail',
          isCompare: true,
          isBold: true,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm'
            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob_date',
            }, {
              name: this.formData.id_type_language,
              field: 'id_no'
            }, {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },{
              name: 'Mobile Number',
              field: 'mobile_no',

            },
            {
              name: 'Email',
              field: 'email',
            },
            {
              name: 'Occupation',
              field: 'occ',
              // fieldCode: 'occupation',
              // option: 26,
            },
            {
              name: 'Are there joint owners?',
              field: 'joint_owner_ind',
              fieldCode: 'yesNoOptions',
              notShow:isTenat,
              option: 1
            },
          ],
          list1: [
            {
              name: 'Company Name',
              field: 'isrd_com_nm'
            }, {
              name: 'Business Registration Number',
              field: 'id_no'
            },
            // {
            //   name: 'CI Number',
            //   field: 'ci_no'
            // },
            {
              name: 'Company Phone No.',
              field: 'phone_no'
            }, {
              name: 'Company Email',
              field: 'email'
            }, {
              name: 'Nature of Business',
              field: 'bsns_nature',
              // fieldCode: 'industry',
              // option: 26
            },
            {
              name: 'Are there joint owners?',
              field: 'joint_owner_ind',
              fieldCode: 'yesNoOptions',
              notShow:isTenat,
              option: 1
            },

            // {
            //   name: 'Contact Person',
            //   isSumbTitle: true
            // },
            {
              name: 'Contact Person Name',
              field: 'contact_nm',

            },
            // {
            //   name: 'Occupation',
            //   field: 'contact_occ_id',
            //   fieldCode: 'occupation',
            //   option: 24,
            // },
            {
              name: 'Contact Person Mobile No.',
              field: 'contact_phone',
            },
            // {
            //   name: 'Email',
            //   field: 'contact_email',
            //
            // },
          ]
        },

        // {
        //   title: 'Coverage',
        //   isSum: true,
        //   isBold: true,
        //   list: [
        //     {
        //       name: 'Sum Insured',
        //       field: 'sum_insured',
        //       isSum: true,
        //     }
        //   ]
        // },
        // {
        //   title: 'Section 1 – Household Contents “All Risks”',
        //   isBold: false,
        //   list: [
        //     {
        //       name: 'Mobile Phone 1 Model declaration',
        //       field: 'phone_mdl_1'
        //     },
        //     {
        //       name: 'Mobile Phone 2 Model declaration',
        //       field: 'phone_mdl_2'
        //     }
        //   ]
        // },
      ]
      let address_arr=[
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
      ]
      let join_arr=[{
        title: 'Joint Policyholder Details',
        isBold: false,
        list: [
          {
            name: 'Joint Policyholder - Full Name',
            field: 'joint_owner_nm',
          },
          {
            name: 'Date of Birth',
            field: 'joint_owner_dob',
            option:2
          },
          {
            name: this.getOptionName('personalIdTypOptions', this.formData.joint_owner_id_type),
            field: 'joint_owner_id_no',
          },
        ]
      }]
      if(this.formData.joint_owner_ind==1){
        list = [...list,...join_arr,...address_arr]
      }else {
        list = [...list,...address_arr]
      }
      if(this.hasBenefitsTab) {
        // const { domestic_helper_info = [], pet_info = [] } = this.formData
        const domestic_helper_info = this.formData.domestic_helper_info || []
        const pet_info = this.formData.pet_info || []

        const { phone_mdl_1, phone_mdl_2 } = this.formData

        let domesticList = []
        for(let i = 0; i < domestic_helper_info.length; i++) {
          domesticList = [
            ...domesticList,
            {
              name: 'Field',
              value: 'Domestic Helper ' + (i+1),
              type: 'value',
              class: 'mg-t-10'
            },
            {
              name: 'Name',
              value: domestic_helper_info[i].name,
              type: 'value'
            },
            {
              name: 'Nationality',
              // value: domestic_helper_info[i].nationality,
              type: 'value',
              value: this.getAllOptionName26('nationality', domestic_helper_info[i].nationality),
              // option: 10,
            },
            {
              name: 'Date of Birth',
              value: domestic_helper_info[i].dob_date,
              type: 'value'
            },
            {
              name: 'Identification',
              value: this.getOptionName('personalIdTypOptions', domestic_helper_info[i].id_type),
              type: 'value'
            },
            {
              name: 'HKID / Passport Number',
              value: domestic_helper_info[i].id_no,
              type: 'value'
            },
            // {
            //   name: 'HKID / Passport',
            //   type: 'file',
            //   value: domestic_helper_info[i].id_type_pic
            // }
          ]
        }
        let petList = []
        for(let i = 0; i < pet_info.length; i++) {
          petList = [
            ...petList,
            {
              name: 'Field',
              value: 'Pet ' + (i+1),
              type: 'value'
            },
            {
              name: 'Type of Pet',
              value: this.getAllOptionName26('type_of_pet', pet_info[i].type_of_pet),
              type: 'value'
            },
            {
              name: 'Pet Name',
              value: pet_info[i].name,
              type: 'value'
            },
            {
              name: 'Year of Birth',
              value: pet_info[i].dob,
              type: 'value'
            },
            {
              name: 'Microchip No.',
              value: pet_info[i].microchip_no,
              type: 'value'
            },
            // {
            //   name: 'Microchip Copy',
            //   type: 'file',
            //   value: pet_info[i].microchip_copy_pic
            // }
          ]
        }

        let benefitsList = [
          {
            title: 'More Benefits Detail',
            boxClass: 'mg-b-0',
            isBold: true,
            class: 'mg-b-0 pd-b-0',
          }
        ]

        if(this.hasBenefitsEmployees && domesticList && domesticList.length > 0) {
          benefitsList = [
            ...benefitsList,
            {
              title: 'Domestic Helper Information',
              isBold: false,
              list: domesticList
            }
          ]
        }

        if(this.hasBenefitsPets && petList && petList.length > 0) {
          benefitsList = [
            ...benefitsList,
            {
              title: 'Pet Information',
              isBold: false,
              list: petList
            }
          ]
        }

        if(this.hasBenefitsPhone) {
          benefitsList = [
            ...benefitsList,
            {
              title: 'Accidental Damage to Mobile Phone',
              isBold: false,
              list: [
                {
                  name: 'Mobile Phone Model Name 1',
                  value: phone_mdl_1,
                  type: 'value'
                },
                {
                  name: 'Mobile Phone Model Name 2',
                  value: phone_mdl_2,
                  type: 'value'
                },
              ]
            }
          ]
        }

        list = [
          ...list,
          ...benefitsList
        ]
      }
      let frist = list[0].list
      let{ bsc_sum_insured_language,coverage_id,post_ind} = this.formData||{}
      if(bsc_sum_insured_language){
        frist.splice(frist.length / 2, 0, {
          name: 'Sum Insured of Building Structure',
          field: 'bsc_sum_insured_language',
        })
        list[0].list = frist
      }
      frist.splice(frist.length / 2, 0, {
        name: 'Coverage',
        field: 'home_coverage_language',
      })
      if(coverage_id==3){
        frist.splice(frist.length-4, 0, {
          name: 'Do you need us to post a copy of the policy document to the Mortgagee?',
          field: 'post_ind',
          fieldCode: 'yesNoOptions',
          option: 1
        })
        if(post_ind==1){
          frist.splice(frist.length-4, 0, {
            name: 'Name of Mortgagee',
            field: 'post_nm_id',
            fieldCode: 'mortgagor',
            type: 'value',
            value:post_name ,
            option: 26
            // notShow:this.formData.post_ind==2,
          })
          frist.splice(frist.length-4, 0, {
            name: 'Address of Mortgagee',
            field: 'post_addr',
            fieldCode: 'post_addr',
          })
        }
      }
      list[0].list = frist
      return list
    },
    hasBenefitsTab() {
      const { benefits = [] } = this.formData
      const { benefit_coverage = {} } = this.formData
      let {domestic_helper,mobile_phone,pet} = benefit_coverage||{}

      // if(!benefits || benefits.length < 1) {
      //   return false
      // }
      // let result = false
      // benefits.some(item => {
      //   if([1, 4, 8].includes(item)) {
      //     result = true
      //     return true
      //   }
      // })
      // return result
      return domestic_helper||mobile_phone||pet
    },
    hasBenefitsEmployees() {
      const { benefits = [] } = this.formData
      const { benefit_coverage ={} } = this.formData
      const {domestic_helper=false} = benefit_coverage||{}
      return domestic_helper
    },
    hasBenefitsPets() {
      const { benefit_coverage ={} } = this.formData
      const {pet=false} = benefit_coverage||{}
      return pet
    },
    hasBenefitsPhone() {
      const { benefit_coverage ={} } = this.formData
      const {mobile_phone=false} = benefit_coverage||{}
      return mobile_phone
    },
  },
  methods: {
    getClientName(data){
      let {client_name=''} = data||''
      return client_name
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompare(item, field,sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 10:
            let {pcy_cmnt_dt=''} = this.formData||{}
            change=pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
            break
          case 24:
            change = this.getAllOptionName24(item.fieldCode, field)
            break
          case 26:
            change = this.getAllOptionName26(item.fieldCode, field)
            break
          case 2:
            change = dayjs(field).format('DD-MM-YYYY')
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.isSum) {
        change = OMath.formatMoney(field, 2, true) + 'HK$'
      }
      return change
    },
    getName(id){
      let data = this.nationalityOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-info {
  .box {
    margin-bottom: 15px;
  }
  .mg-b-0 {
    margin-bottom: 0!important;
  }

  .title {
    display: block;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }

  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
